import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { USERS } from '../../../constants/applicationConstants';
import { DataTableHoc, ErrorFallback } from 'smart-react';
import Loader from '../../Core/Components/Loader/Loader';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../constants/applicationConstants';
import {
  deleteFilter,
  applyFilter,
  saveFilters,
} from '../../../Utils/Filters/filterSliderHandler';
const BaseUserDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable')
);
const UserDataTable = DataTableHoc(BaseUserDataTable);

/**
 * Users main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Users component.
 */
const Users = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns();
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="app-data-page">
        <React.Suspense fallback={<Loader />}>
          <UserDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={USERS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={USERS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${USERS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${USERS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default Users;
